{
  "actions": {
    "submit": "Submit",
    "submitting": "Submitting...",
    "close": "Close",
    "contactSupport": "Contact Support",
    "redirectNow": "Redirect Now"
  },
  "paginator": {
    "previous": "Previous",
    "next": "Next",
    "showingRange": "Showing {{start}} - {{end}}",
    "ofResults": "of {{count}} results",
    "ofResults_one": "of {{count}} results",
    "ofResults_other": "of {{count}} results"
  },
  "fields": {
    "email": { "label": "Email" },
    "firstName": { "label": "First name" },
    "lastName": { "label": "Last name" },
    "phoneNumber": { "label": "Phone number" },
    "jobTitle": { "label": "Job title" },
    "title": { "label": "Title" },
    "description": { "label": "Description" }
  },
  "errors": {
    "oops": "Oops!",
    "title": "Error",
    "occurred": "An error occurred",
    "unexpected": "Something went wrong. Please try again later.",
    "invalidRequest": "Invalid request"
  },
  "notFound": {
    "title": "Page not found.",
    "description": "Sorry, we couldn't find the page you're looking for.",
    "goHome": "Go back home"
  },
  "errorPage": {
    "title": "Oops!",
    "body": "An error occurred. Please refresh the page and if the problem persists, please <supportLink>contact support</supportLink>.",
    "returnToLogin": "Return to Login"
  },
  "redirect": {
    "countdown_one": "Redirecting in {{count}} second...",
    "countdown_other": "Redirecting in {{count}} seconds..."
  },
  "smsOptIn": {
    "optional": "(Optional)",
    "consent": "By checking this box, you agree to receive recurring SMS messages from Ande, including promotional content. Message frequency varies. Message and data rates may apply. Reply STOP to cancel. Reply HELP for help.",
    "fullTermsLink": "Full Terms",
    "modalTitle": "SMS Terms",
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms of Service",
    "conjunction": "and",
    "dismiss": "Dismiss",
    "fullTermsBodyBeforeSupportEmail": "By providing your phone number and opting in, you agree to receive recurring SMS/text messages from Ande, including transactional notifications and promotional messages. Message frequency varies. Message and data rates may apply. Mobile carriers are not liable for delayed or undelivered messages. Reply STOP to cancel. Reply HELP for help or contact ",
    "fullTermsBodyAfterSupportEmail": ". Consent is not a condition of any purchase."
  },
  "andeAgentCardLink": {
    "metaTitle": "Add a card · Ande",
    "unavailable": {
      "title": "This link is not available",
      "body": "It may have expired, been replaced by a newer link, or already been used. Ask Ande for a new link."
    },
    "errors": {
      "cardNotAdded": "The card could not be added.",
      "invalidAction": "Invalid action.",
      "linkExpired": "This link expired or the card could not be added. Ask Ande for a new link."
    },
    "success": {
      "title": "Your card is on file",
      "body": "{{brand}} ending in {{lastFour}}. Ande has it now; you can go back to your messages.",
      "cardFallback": "Card"
    },
    "form": {
      "titleWithName": "{{firstName}}, add a card on file",
      "titleGeneric": "Add a card on file",
      "addCard": "Add a card",
      "preparing": "Preparing…"
    }
  },
  "andeLinePaymentRecovery": {
    "brand": "Ande Line",
    "unavailable": {
      "title": "This payment link is not available",
      "body": "The link may have expired, been replaced, or already been used. Return to SMS and request a new payment link."
    },
    "errors": {
      "linkUnavailable": "This payment recovery link is not available.",
      "paymentMethodIncomplete": "The payment method could not be completed.",
      "invalidAction": "Invalid action.",
      "linkExpired": "This link expired or the payment method could not be updated. Request a new link."
    },
    "success": {
      "title": "Your card is updated",
      "bodyBound": "Return to SMS and reply YES to continue your pending request.",
      "bodyUnbound": "Return to SMS and request a new review. Check the details, then reply YES to confirm."
    },
    "form": {
      "title": "Update your Ande Line card",
      "introWithName": "{{firstName}}, add a live card to continue your reservation request.",
      "introGeneric": "Add a live card to continue your reservation request.",
      "addPaymentMethod": "Add payment method",
      "preparing": "Preparing…"
    },
    "currentCard": {
      "heading": "Current default card",
      "summary": "{{brand}} ending in {{lastFour}}, expires {{expiration}}",
      "cardFallback": "Card",
      "none": "No default card is available."
    }
  }
}
